import React from "react";
import secIcon from "../../assets/images/sec_icon.png";

export default function PujaSection() {
 
  return (
    <section>
      <div className="puja_section space_sec">
        <div className="container">
          <div className="heading_sec text-center">
            <h2 className="purple_clr">Online Puja</h2>
            <h5 className="gray_clr">
              (For Customized Horoscope Go to Personalized Report section)
            </h5>
          </div>

          <div className="banner_block pt-0 d-flex flex-wrap align-items-center">
            {/* Column 1 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Rahu Shanti Path{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 2 */}
            <div className="banner_col">
              <div className="banner_box pr-2">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Shani Shanti Path{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 3 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Ketu Shanti Path{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 4 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Nav-Grah Shanti Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 5 */}
            <div className="banner_col">
              <div className="banner_box pr-2">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Bhakut-Dosh Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 6 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Rudrabhishek Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 7 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Baglamukhi Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 8 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Kaalsarp-Dosh Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 9 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Karna-Pishachani Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 10 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Sundarkant Path Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 11 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Chhinnmastika Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            {/* Column 12 */}
            <div className="banner_col">
              <div className="banner_box">
                <span>
                  <img src={secIcon} alt="icon" className="img-fluid sec_icon" />
                </span>
                <div className="banner_box_inner">
                  <h5>
                    Online Puja{" "}
                    <span className="d-block pe-md-4">
                      Your trusted partner in the world of astrology and related
                      services.
                    </span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}